<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-btn text
        class="modal-cta"
        :class="[{active: showHD}, colorClass]"
        :disabled="!hasHD"
        @click="toggleHD">HD Image</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn text class="modal-cta" @click="centerFovea">{{centerText()}}</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn text
        class="modal-cta"
        :class="[{active: hasColorPalette}, colorClass]"
        @click="toggleColor">Color</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn text
        class="modal-cta"
        :class="[{active: isInverted}, colorClass]"
        @click="invertColor">Invert</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn
        text
        v-if="sliceHasSegmentation"
        class="modal-cta"
        :class="[{active: showSegmentation}, colorClass]"
        @click="toggleSegmentation">Segmentation</v-btn>
    </v-flex>
    <v-flex xs12>
      <reset-slider
        :value="thicknessMapOpacity"
        :color="colorHex"
        :min="0"
        :max="1"
        :step="0.05"
        :defaultValue="0.5"
        @input="updateOpacity"
        name="Color Intensity"/>
    </v-flex>
    <v-flex xs12
      v-if="!isOpticDisc">
      <v-btn text
        class="modal-cta"
        :class="[{active: showETDRS}, colorClass]"
        @click="toggleETDRS">ETDRS</v-btn>
    </v-flex>
    <v-flex xs12 v-if="centerAverageThickness">
      <span class="cirrus-data-header">CENTRAL SUBFIELD THICKNESS (µm)</span>
      <br>
      <span class="cirrus-data-value">{{formatNumber(centerAverageThickness * 1000)}}</span>
    </v-flex>
    <v-flex xs12 v-if="overallVolume">
      <span class="cirrus-data-header">CUBE VOLUME (mm²)</span>
      <br>
      <span class="cirrus-data-value">{{formatNumber(overallVolume)}}</span>
    </v-flex>
    <v-flex xs12 v-if="overallAverageThickness">
      <span class="cirrus-data-header">CUBE AVERAGE THICKNESS (µm)</span>
      <br>
      <span class="cirrus-data-value">{{formatNumber(overallAverageThickness * 1000)}}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import resetSlider from "../../controls/ResetSlider";
import { mapGetters } from "vuex";
import { SeriesTypes } from "../../../config/config";

export default {
  name: "cirrusSidebarControls",
  components: { resetSlider },
  computed: {
    ...mapGetters([ "showHD", "isInverted", "hasColorPalette", "showSegmentation", 
    "showETDRS", "thicknessMapOpacity", "centerAverageThickness", "overallVolume", 
    "overallAverageThickness", "sliceHasSegmentation", "hdVerts",
      "hdHorzs", "seriesType", "hasHD"])
  },
  methods: {
    toggleHD() {
      this.$store.commit("toggleHD");
    },
    centerFovea() {
      this.$store.commit("centerFovea");
    },
    toggleColor() {
      this.$store.dispatch("toggleColorPalette");
    },
    invertColor() {
      this.$store.dispatch("toggleInverted");
    },
    toggleSegmentation() {
      this.$store.commit("toggleSegmentation");
    },
    toggleETDRS() {
      this.$store.commit("toggleETDRS");
    },
    updateOpacity(opacity) {
      this.$store.commit("updateThicknessMapOpacity", opacity);
    },
    formatNumber(value) {
      return (value && value.toFixed(1)) || "";
    },
    isOpticDisc() {
      return this.seriesType == SeriesTypes.OpticDisc;
    },
    centerText() 
    {
      if (this.isOpticDisc())
        return "Center";
      return "Center FOVEA" 
    }
  }
};
</script>

<style lang="scss" scoped>
.cirrus-data-value {
  font-size: 25px;
}

.v-btn {
  margin: 6px 0px;
}
</style>
